import React from "react";
import styled, { css } from "styled-components";
import PropTypes from "prop-types";
import Price from "components/Price";

const Row = styled.div`
  display: grid;
  grid-template-columns: 50% 25% 25%;
  padding: ${({ showBorder }) => (showBorder ? "0.5rem 0" : ".5rem 0 0 0")};
  border-bottom: ${({ theme, showBorder }) =>
    showBorder ? `0.0625rem solid ${theme.themeColors.lightGrey}` : "none"};
  margin-bottom: ${({ showBorder }) => (showBorder ? "0.5rem" : "0")};

  ${({ theme }) => theme.mq.sm`
    grid-template-columns: 50% 25% 25%;
  `}
`;

const Service = styled.div`
  color: ${({ theme }) => theme.themeColors.darkGreen1};
  display: flex;
  font-size: 0.875rem;
  font-weight: 400;
  justify-content: flex-start;

  ${({ isDuration }) =>
    isDuration &&
    css`
      grid-row-start: 2;
      color: ${({ theme }) => theme.themeColors.darkGreen4};
      justify-content: flex-start;

      ${({ theme }) => theme.mq.sm`
        grid-column-start: 2;
        grid-row-start: 1;
        justify-content: flex-end;
      `}
    `}

  ${({ isPrice }) =>
    isPrice &&
    css`
      grid-column-start: 3;
      font-weight: 600;
      justify-content: flex-end;
    `}
`;

function ServiceRow({ service, showBorder }) {
  const price = () => {
    if (!service?.attributes?.price) {
      return "-";
    }
    const value =
      (service?.attributes?.price || service?.attributes?.priceInt/100 || 0);
    return <Price value={value} />;
  };
  return (
    <Row key={`${service?.id}-service-row`} showBorder={showBorder}>
      <Service>{service?.attributes?.name}</Service>
      {service?.attributes?.duration && (
        <Service isDuration>
          {service?.attributes?.duration}
          {service?.attributes?.duration && " min"}
        </Service>
      )}
      <Service isPrice>{price()}</Service>
    </Row>
  );
}

ServiceRow.propTypes = {
  service: PropTypes.object.isRequired,
  showBorder: PropTypes.bool,
};

ServiceRow.defaultProps = {
  showBorder: true,
};

export default ServiceRow;
